import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { SDAC_EMAIL } from '../../constants';
import { mailto } from '../../js/utility';

class AdditionalInfo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      additionalInfo,
      showTitle,
      isScrollable,
      t,
    } = this.props;

    const search_replace_sdac_email = mailto(SDAC_EMAIL);

    return (
      additionalInfo && additionalInfo.length > 0 && additionalInfo[0].subject !== null ?
        <section className={`fe-trip-addinfo ${(isScrollable) ? 'scrollable' : ''}`}>
          <div className="container">
            <div className="row position-relative">
              {/* <div className="col-lg-8"> */}
              {(showTitle) ? (
                <h4 className="fe-trip-main-heading">{t('trip:additionalInfo')}</h4>
              ) : null}
              {additionalInfo.map((info) => (
                <div key={ info.id } className="fe-trip-addinfo-item">
                  <h5 className="fe-trip-addinfo-subject">{ info.subject }</h5>
                  <div
                    className="fe-trip-addinfo-content"
                    dangerouslySetInnerHTML={{__html: search_replace_sdac_email(info.text)}}
                  />
                </div>
              ))}
              {/* </div> */}
            </div>
          </div>
        </section> :
        null
    );
  }
}

AdditionalInfo.propTypes = {
  additionalInfo: PropTypes.array.isRequired,
  showTitle: PropTypes.bool,
  isScrollable: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AdditionalInfo);
